import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {contact, contacts,contactsAll,cttgroups,cttgroup,cttgp,contactImportAttendees,contactExpQrcode, contactImport, contactExport, importContactAvatar} = api

export async function batchAvatar(params) {
    return request({url: importContactAvatar, method: 'post', data: params})
}
/**
 * 导入联系人
 */
export async function importContact(params) {
    return request({url: contactImport, method: 'post', data: params,})
}
/**
 * 导出联系人
 */
export async function exportContact(params) {
    return request({url: contactExport, method: 'post', data: params,})
}
/**
 * 查找联系人详情
 */
export async function findContact(params) {
    return request({url: contact, method: 'get', data: params,})
}
/**
 * 更新联系人群组
 */
export async function updateContactGroups(params) {
    return request({url: contact, method: 'patch', data: params,})
}

/**
 * 创建通讯录记录
 */
export async function createContact(params) {
    return request({url: contacts, method: 'post', data: params,})
}

/**
 * 更新通讯录记录
 */
export async function updateContact(params) {
    return request({url: contact, method: 'put', data: params,})
}

/**
 * 删除通讯录联系人
 */
export async function deleteContact(params) {
    return request({url: contact, method: 'delete', data: params,})
}

/**
 * 删除通讯录联系人
 */
export async function deleteContactAll(params) {
    return request({url: contactsAll, method: 'delete', data: params,})
}



/**
 * 查找通讯录记录列表
 */
export async function findContacts(params) {
    return request({url: contacts, method: 'get', data: params,})
}

/**
 * 批量删除通讯录联系人
 */
export async function deleteContacts(params) {
    return request({url: contacts, method: 'delete', data: params,})
}
/**
 * 查找通讯录分组
 */
export async function findCttgroups(params) {
    return request({url: cttgroups, method: 'get', data: params,})
}
/**
 * 创建通讯录分组
 */
export async function createCttgroups(params) {
    return request({url: cttgroups, method: 'post', data: params,})
}
/**
 * 更新通讯录分组
 */
export async function updateCttgroup(params) {
    return request({url: cttgroup, method: 'put', data: params,})
}
/**
 * 更新通讯录分组
 */
export async function deleteCttgroup(params) {
    return request({url: cttgroup+"??deletePerson="+params.deletePerson, method: 'delete', data: params,})
}
/**
 * 添加通讯录到分组
 */
export async function addCttgp(params) {
    return request({url: cttgp, method: 'post', data: params,})
}
/**
 * 查询通讯录到分组成员
 */
export async function findCttgps(params) {
    return request({url: cttgp, method: 'get', data: params,})
}
/**
 * 删除通讯录到分组成员
 */
export async function deleteCttgps(params) {
    return request({url: cttgp, method: 'delete', data: params,})
}/**
 * 下载二维码
 */
export async function expQrcodeContact(params) {
    return request({url: contactExpQrcode, method: 'post', data: params,})
}
/**
 * 参与人导入通讯录
 */
export async function impAttendeesContact(params) {
    return request({url: contactImportAttendees, method: 'post', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/contact.js